<template>
  <div class="vx-card" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '23') != null">
    <h1 class="card-bg p-6 text-center mt-4">TAKIM YÖNETİMİ</h1>
    <div class="proje_cards pt-6 mb-5">
      <div class="proje_card left mb-5">
        <h2 class="card-bg p-6 mb-3 text-center hoverHeading" @click="showSearchTeam = !showSearchTeam">
          <span class="mr-2"><feather-icon icon="SearchIcon" svgClasses="h-6 w-6" /></span><span>Takım Arama</span>
        </h2>

        <div v-if="showSearchTeam" class="card-bg p-5">
          <form @submit.prevent="getTeam()">
            <div class="inputs tFlex tFlex_ai-s gap-1 mb-5">
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Takım Adı</b></label>
                <v-select @input="getTeam()" name="Id" v-model="teamSearch.id" placeholder="Takım Seçiniz" :options="teamSearchList" label="name" class="w-full" :reduce="(row) => row.id">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Email</b></label>
                <vs-input size="large" type="text" style="width: 100%;" v-model="teamSearch.email" />
              </div>
            </div>

            <div class="tFlex tFlex_column tFlex_ai-c tFlex_jc-c mb-3 gap-1">
              <vs-button color="success" class="width-110">Ara</vs-button>
            </div>
          </form>
        </div>
      </div>

      <div class="right mb-5">
        <h2 class="mb-3 card-bg text-center hoverHeading proje_card p-6" @click="showAddTeam = !showAddTeam">
          <span class="mr-2"><feather-icon icon="EditIcon" svgClasses="h-6 w-6" /></span><span>Takım Oluştur</span>
        </h2>
        <div v-if="showAddTeam" class="card-bg p-5">
          <div class="projects tFlex gap-1 mb-3">
            <div class="left flex-1">
              <div class="mb-5">
                <label class="text-sm"><b>Takım Adı</b></label>
                <vs-input type="text" v-model="teamItem.name" placeholder="Takım Adı" style="width: 100%;" />
              </div>
            </div>
            <div class="right flex-1">
              <div class="mb-5">
                <label class="text-sm"><b>Departman Id</b></label>

                <v-select name="Id" v-model="teamItem.departmentId" placeholder="Departman Seçiniz" :options="departmentList" label="name" class="w-full" :reduce="(row) => row.id">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>
            <div class="right flex-1">
              <div class="mb-5">
                <label class="text-sm"><b>Email</b></label>
                <vs-input type="text" style="width: 100%;" v-model="teamItem.email" placeholder="Email" />
              </div>
            </div>
          </div>

          <div class="tFlex tFlex_jc-c">
            <vs-button color="success" class="width-220" @click="SaveTeam(teamItem, 'Insert', '')">Takım Ekle</vs-button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-bg mb-5 p-5">
      <h2 class="text-center hoverHeading">
        <span class="mr-2"><feather-icon icon="BriefcaseIcon" svgClasses="h-6 w-6" /></span><span>Takımlar</span>
      </h2>

      <div class="vx-row w-full">
        <div class="vx-col w-full mb-5">
          <vs-table search :maxItems="10" :pagination="true" :data="teamList">
            <template slot="thead">
              <vs-th>Id</vs-th>
              <vs-th>Takım Adı</vs-th>
              <vs-th>Departman</vs-th>
              <vs-th>Email</vs-th>

              <vs-th>İşlemler</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(tr, i) in data">
                <template v-if="tr.id">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap; width: 10%;">
                    <b> {{ tr.id }}</b>
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="width: 20%;">
                    <vs-input type="text" v-model="tr.name" style="width: 300px;" />
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="width: 30%;">
                    <v-select name="Id" v-model="tr.departmentId" :options="departmentList" label="name" class="w-full" :reduce="(row) => row.id">
                      <span slot="no-options">Eşleşen Veri Yok</span>
                    </v-select>
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="width: 10%;">
                    <vs-input type="text" v-model="tr.email" style="width: 300px;" />
                  </vs-td>

                  <vs-td style="width: 10%;">
                    <feather-icon icon="TrashIcon" title="Sil" svgClasses="h-6 w-6 hover:text-warning text-danger cursor-pointer" @click.stop="SaveTeam(tr, 'Delete', 'Takım silinecektir')" />
                    <feather-icon icon="EditIcon" title="Güncelle" svgClasses="h-6 w-6 ml-5 hover:text-warning text-success cursor-pointer" @click.stop="SaveTeam(tr, 'Update', '')" />
                  </vs-td>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

// Cell Renderer

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      teamItem: { id: null, name: null, departmentId: null, email: null },
      teamList: [],
      teamSearchList: [],
      teamSearch: { id: null, name: null, email: null },
      departmentList: [],
      departmentSearch: { id: null, name: null },

      showAddTeam: false,
      showSearchTeam: false,
    };
  },

  computed: {},
  methods: {
    getTeam: async function () {
      this.$vs.loading();
      this.teamList = await repository.postEntity("ParametricScreens/GetTeam", this.teamSearch).then((r) => r.list);
      this.$vs.loading.close();
    },
    getTeamSearch: async function () {
      this.$vs.loading();
      this.teamSearchList = await repository.postEntity("ParametricScreens/GetTeam", this.teamSearch).then((r) => r.list);
      this.$vs.loading.close();
    },
    getDepartment: async function () {
      this.$vs.loading();
      this.departmentList = await repository.postEntity("ParametricScreens/GetDepartment", this.departmentSearch).then((r) => r.list);
      this.$vs.loading.close();
    },

    SaveTeam: async function (item, operation, messageText) {
      //Insert,Update,Delete
      item.operation = operation;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("ParametricScreens/SaveTeam", item);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.teamItem = {};
      this.teamSearch = {};
      this.getTeam();
    },
  },

  beforeMount() {},
  beforeUpdate() {},
  mounted() {},
  created: async function () {
    this.$vs.loading();
    await Promise.all([this.getTeam(), this.getDepartment(), this.getTeamSearch()]);

    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
body {
  overflow: auto;
}
.vs-dialog {
  max-width: 1366px !important;
  max-height: 95% !important;
}
</style>
